<template>
  <div>
    <!-- Header -->
    <risoulHeader
      :cartQuantity="quantityShopping"
      :snackbar="snackbar"
      :updateShopingQuantity="updateShopingQuantity"
      :parentCategory="parentCategory"
      :key="quantityShopping"
      @langHeaderSelection="handleLangSelected"
    ></risoulHeader>

    <!-- Banner Img -->
    <v-container v-if="showBanner" fluid class="banner-container pt-3">
      <v-row>
        <v-col class="banner" sm="12" md="12" lg="12">
          <v-card class="mx-auto">
            <v-img
              class="hidden-sm-and-down"
              height="145px"
              alt="text"
              :src="url"
              lazy-src
            ></v-img>
            <v-img
              class="hidden-md-and-up"
              alt="text"
              :src="url"
              lazy-src
            ></v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Body Page -->

    <v-container class="mt-4 content-container" v-if="$route.name != 'home'">
      <div v-if="loading">
        <v-row justify="center">
          <RingLoader :color="'rgba(238, 117, 4, 0.993)'" />
        </v-row>
      </div>

      <div v-else>
        <v-row>
          <v-col class="pt-4 pb-6 px-6" sm="8" md="9" lg="9">
            <!-- <div v-if="!hideBreadcrumbs"> -->
            <div>
              <v-breadcrumbs class="pa-0" :items="navigationItems" divider=">">
              </v-breadcrumbs>
            </div>
          </v-col>
        </v-row>

        <v-main fill-height>
          <router-view
            :quantityShopping="quantityShopping"
            :parentCategory="parentCategory"
            :updateShopingQuantity="updateShopingQuantity"
            :sendSnack="snackbar"
          />
        </v-main>
      </div>
    </v-container>

    <v-main v-else fill-height>
      <router-view
        :quantityShopping="quantityShopping"
        :parentCategory="parentCategory"
        :updateShopingQuantity="updateShopingQuantity"
        :sendSnack="snackbar"
      />
    </v-main>

    <!-- Footer -->
    <div class="footer-container">
      <v-container>
        <v-row>
          <v-col md="7" lg="7" sm="12" cols="12">
            <v-container>
              <!-- Menú -->
              <v-row>
                <v-col md="6" lg="6" sm="12" cols="12">
                  <div class="footer-title">
                    {{ currentText.footer.menu }}
                  </div>
                  <div class="footer-list">
                    <ul>
                      <li>
                        <a href>{{ currentText.menu.category }}</a>
                      </li>
                      <li>
                        <a href>{{ currentText.menu.brands }}</a>
                      </li>
                      <li>
                        <a href>{{ currentText.menu.orders }}</a>
                      </li>
                      <li>
                        <a href>{{ currentText.menu.tracking }}</a>
                      </li>
                      <li>
                        <a href>{{ currentText.menu.search }}</a>
                      </li>
                    </ul>
                  </div>
                </v-col>

                <!-- Blog -->
                <v-col md="6" lg="6" sm="12" cols="12">
                  <div class="footer-title">
                    {{ currentText.footer.blog }}
                  </div>

                  <div class="footer-list">
                    <ul>
                      <li
                        v-for="post in currentText.footer.blogPosts"
                        :key="post.id"
                      >
                        <a target="_blank" :href="post.url">
                          {{ post.title }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </v-col>
              </v-row>

              <!-- Sales -->
              <v-row>
                <v-col>
                  <div class="footer-title">
                    {{ currentText.footer.sales }}
                  </div>
                </v-col>
              </v-row>

              <!-- Puntos de Venta -->
              <v-row>
                <v-col md="4" lg="4" sm="6" cols="12" class="pa-0">
                  <div class="footer-list" fluid>
                    <ul>
                      <li
                        v-for="location in footer.locations1"
                        :key="location.title"
                      >
                        <a target="_blank" :href="location.url">
                          {{ location.title }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </v-col>

                <v-col md="4" lg="4" sm="6" cols="12" class="pa-0">
                  <div class="footer-list" fluid>
                    <ul>
                      <li
                        v-for="location in footer.locations2"
                        :key="location.title"
                      >
                        <a target="_blank" :href="location.url">
                          {{ location.title }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </v-col>

                <v-col md="4" lg="4" sm="6" cols="12" class="pa-0">
                  <div class="footer-list" fluid>
                    <ul>
                      <li
                        v-for="location in footer.locations3"
                        :key="location.title"
                      >
                        <a target="_blank" :href="location.url">
                          {{ location.title }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-col>

          <v-col md="1" lg="1" sm="12" cols="12"></v-col>

          <!-- Boletin -->
          <v-col md="4" lg="4" sm="12" cols="12">
            <v-container>
              <v-row>
                <div class="footer-title">
                  {{ currentText.footer.newsletter }}
                </div>
              </v-row>

              <v-row>
                <div class="footer-caption">
                  {{ currentText.footer.newsletterText }}
                </div>

                <br />
                <br />
              </v-row>
              <!-- <v-row>
                <v-text-field
                  :label="currentText.footer.name"
                  outlined
                  dense
                  background-color="white"
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                  :label="currentText.footer.mail"
                  outlined
                  dense
                  background-color="white"
                ></v-text-field>
              </v-row> -->
              <v-row>
                <v-btn
                  href="http://www.risoul.com.mx/landing-suscribete-a-nuestro-boletin"
                  color="secondary"
                >
                  {{ currentText.footer.button }}
                </v-btn>
              </v-row>

              <v-row>
                <div class="footer-title pa-0">
                  {{ currentText.footer.follow }}
                </div>
              </v-row>

              <v-row>
                <v-col v-for="item in footer.socialNetworks" :key="item.id">
                  <a target="_blank" :href="item.url">
                    <img :src="item.image" alt height="44" width="44" />
                  </a>
                </v-col>
              </v-row>

              <br />

              <div class="footer-title">Descargar nuestra app</div>

              <div class="boxesapp">
                <!-- PLay Store Image -->
                <a
                  href="https://play.google.com/store/apps/details?id=com.moblico.risoul"
                  target="_blank"
                >
                  <img
                    src="https://risoulimages.s3-us-west-2.amazonaws.com/logos/googleplay.webp"
                    alt="google"
                  />
                </a>

                <!-- App Store Image -->
                <a
                  href="https://apps.apple.com/mx/app/risoul-mx/id1523542595"
                  target="_blank"
                >
                  <img
                    src="https://risoulimages.s3-us-west-2.amazonaws.com/logos/appstore.webp"
                    alt="Appstore"
                  />
                </a>
              </div>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-footer color="#d7d7d7">
      <v-layout justify-center row wrap>
        <v-card flat color="#d7d7d7" class="pt-1 pb-1 pl-2 pr-11">
          <p class="margin0 footer-text">
            Av. Sendero Divisorio, #400 Residencial Casa Bella, San Nicolas de
            Los Garza, C.P. 66428
          </p>
        </v-card>
        <v-card flat color="#d7d7d7" class="pt-1 pb-1 pl-1 pr-11">
          <a
            href="https://www.risoul.com.mx/aviso-de-privacidad"
            target="_blank"
            class="footer-text"
          >
            Politica de Privacidad
          </a>
        </v-card>
        <v-card flat color="#d7d7d7" class="pt-1 pb-1 pl-1 pr-0">
          <p class="margin0 footer-text">
            Desarrollado por &nbsp;
            <a
              class="footer-text"
              href="https://www.risoul.com.mx/"
              target="_blank"
            >
              Risoul
            </a>
          </p>
        </v-card>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import _ from "underscore";
import { RingLoader } from "vue-spinners-css";
import { events } from "../main";
import { coreText } from "../utils/textTranslations";
import risoulHeader from "./../components/header/child_header.vue";

export default {
  name: "core",

  components: { risoulHeader, RingLoader },

  data() {
    return {
      loading: false,
      activeSession: false,
      artQuantity: 0,
      showBanner: false,
      url: "",
      hideBreadcrumbs: true,
      text: JSON.parse(JSON.stringify(coreText)),
      languageLoading: false,
      languages: [{ name: "Español" }, { name: "English" }],
      selectedLanguage: "Español",
      navigationItems: [{ text: "Home", disabled: false, href: "/" }],
      footer: {
        locations1: [
          {
            title: "CD. ACUÑA",
            url: "https://www.risoul.com.mx/sucursales/cd-acuna-piedras-negras",
          },
          {
            title: "CD. DEL CARMEN",
            url: "https://www.risoul.com.mx/sucursales/cd-del-carmen",
          },
          {
            title: "CIUDAD DE MÉXICO",
            url: "https://www.risoul.com.mx/sucursales/mexico-df",
          },
          {
            title: "COATZACOALCOS",
            url: "https://www.risoul.com.mx/sucursales/coatzacoalcos",
          },
          {
            title: "CUAUTITLÁN",
            url: "https://www.risoul.com.mx/sucursales/cuautitlan",
          },
          {
            title: "CUERNAVACA",
            url: "https://www.risoul.com.mx/sucursales/cuernavaca",
          },
          {
            title: "DURANGO",
            url: "https://www.risoul.com.mx/sucursales/durango",
          },
        ],

        locations2: [
          {
            title: "GUERRERO",
            url: "https://www.risoul.com.mx/sucursales/guerrero",
          },
          {
            title: "MATAMOROS",
            url: "https://www.risoul.com.mx/sucursales/matamoros",
          },
          {
            title: "MÉRIDA",
            url: "https://www.risoul.com.mx/sucursales/merida",
          },
          {
            title: "MONCLOVA",
            url: "https://www.risoul.com.mx/sucursales/monclova",
          },
          {
            title: "MONTERREY SUCURSAL MATRIZ",
            url: "https://www.risoul.com.mx/sucursales/monterrey",
          },
          {
            title: "NUEVO LAREDO",
            url: "https://www.risoul.com.mx/sucursales/nuevo-laredo",
          },
          {
            title: "ORIZABA",
            url: "https://www.risoul.com.mx/sucursales/orizaba",
          },
        ],

        locations3: [
          {
            title: "PUEBLA",
            url: "https://www.risoul.com.mx/sucursales/puebla",
          },
          {
            title: "REYNOSA",
            url: "https://www.risoul.com.mx/sucursales/reynosa",
          },
          {
            title: "SALTILLO",
            url: "https://www.risoul.com.mx/sucursales/saltillo",
          },
          {
            title: "TAMPICO",
            url: "https://www.risoul.com.mx/sucursales/tampico",
          },
          {
            title: "TOLUCA",
            url: "https://www.risoul.com.mx/sucursales/toluca",
          },
          {
            title: "TORREÓN",
            url: "https://www.risoul.com.mx/sucursales/torreon",
          },
          {
            title: "VERACRUZ",
            url: "https://www.risoul.com.mx/sucursales/veracruz",
          },
          {
            title: "VILLAHERMOSA",
            url: "https://www.risoul.com.mx/sucursales/villahermosa",
          },
        ],

        socialNetworks: [
          {
            id: "1",
            url: "https://www.facebook.com/RisoulMX/",
            image: require("../assets/social/Facebook_icon.png"),
          },
          {
            id: "2",
            url: "https://www.linkedin.com/company/risoul-y-cia-s.a.-de-c.v.?trk=tyah&trkInfo=clickedVertical%3Acompany%2CclickedEntityId%3A2030155%2Cidx%3A2-1-5%2CtarId%3A1461706907937%2Ctas%3Arisoul",
            image: require("../assets/social/Linkedin_icon.png"),
          },
          {
            id: "3",
            url: "https://twitter.com/RisoulMX",
            image: require("../assets/social/twitter_icon.png"),
          },
          {
            id: "4",
            url: "https://www.youtube.com/channel/UC9moS5ctZRw6C8K0zGIv8mQ",
            image: require("../assets/social/youtube_icon.png"),
          },
          {
            id: "5",
            url: "https://www.instagram.com/risoulmx/",
            image: require("../assets/social/logoinstagram.png"),
          },
        ],
      },
      parentCategory: {
        PDI: [],
        noPDI: [],
      },
    };
  },

  props: {},

  methods: {
    isActiveSession: function () {
      var token, userId;
      token = localStorage.getItem("token");
      userId = localStorage.getItem("userId");
      this.activeSession = token !== null && userId !== null ? true : false;
    },

    updateShopingQuantity: function () {
      var productos = JSON.parse(localStorage.getItem("shoppingCart"));
      this.artQuantity = productos.reduce(function (
        previousValue,
        currentValue
      ) {
        return Number(previousValue) + Number(currentValue.quantity);
      },
      0);
    },

    snackbar: function (message) {
      events.$emit("snackbar", message);
    },

    breadcrumb: function () {
      if (this.$route.name == "home") {
        this.hideBreadcrumbs = true;
      } else {
        this.hideBreadcrumbs = false;
        switch (this.$route.name) {
          case "promo":
            this.navigationItems.push({
              text: "Productos en promoción",
              disabled: true,
              href: "#/promo",
            });
            break;
          case "quickOrder":
            this.navigationItems.push({
              text: "Lista Rápida",
              disabled: true,
              href: "#/list",
            });
            break;
          case "brands":
            this.navigationItems.push({
              text: "Marcas",
              disabled: true,
              href: "#/brands",
            });
            break;
          case "productShowBrand":
            this.navigationItems.push({
              text: "Marcas",
              disabled: false,
              href: "#/brands",
            });
            this.navigationItems.push({
              text: `${this.$route.params.brand}`,
              disabled: true,
              href: "#/brands",
            });
            break;
          case "traking":
            this.navigationItems.push({
              text: "Rastreo",
              disabled: true,
            });
            break;
          case "PDI":
            this.navigationItems.push({
              text: "Soluciones PDI",
              disabled: true,
              href: "#/PDI",
            });
            break;
          case "PDIT2":
            this.navigationItems.push({
              text: "Soluciones PDI",
              disabled: false,
              href: "#/PDI",
            });
            this.navigationItems.push({
              text: `${this.$route.params.PDIT2}`,
              disabled: true,
              href: `#/PDI/${this.$route.params.PDIT2}?idCategory=`,
            });
            break;
          case "PDIT3":
            this.navigationItems.push({
              text: "Soluciones PDI",
              disabled: false,
              href: "#/PDI",
            });
            this.navigationItems.push({
              text: `${this.$route.params.PDIT2}`,
              disabled: true,
              href: `#/PDI/${this.$route.params.PDIT2}?idCategory=`,
            });
            this.navigationItems.push({
              text: `${this.$route.params.PDIT3}`,
              disabled: true,
              href: `#/PDI/${this.$route.params.PDIT2}/${this.$route.params.PDIT3}?idCategory=`,
            });
            break;
          case "PDIT4":
            this.navigationItems.push({
              text: "Soluciones PDI",
              disabled: false,
              href: "#/PDI",
            });
            this.navigationItems.push({
              text: `${this.$route.params.PDIT2}`,
              disabled: true,
              href: `#/PDI/${this.$route.params.PDIT2}?idCategory=`,
            });
            this.navigationItems.push({
              text: `${this.$route.params.PDIT3}`,
              disabled: true,
              href: `#/PDI/${this.$route.params.PDIT2}/${this.$route.params.PDIT3}?idCategory=`,
            });
            this.navigationItems.push({
              text: `${this.$route.params.PDIT4}`,
              disabled: true,
              href: `#/PDI/${this.$route.params.PDIT2}/${this.$route.params.PDIT3}/${this.$route.params.PDIT4}?idCategory=`,
            });
            break;
          case "category":
            this.navigationItems.push({
              text: "Categorías",
              disabled: true,
              href: "#/category",
            });
            break;
          case "categoryT2":
            this.navigationItems.push({
              text: "Categorías",
              disabled: false,
              href: "#/category",
            });
            this.navigationItems.push({
              text: `${this.$route.params.categoryT2}`,
              disabled: true,
              href: `#/category/${this.$route.params.categoryT2}?idCategory=`,
            });
            break;
          case "categoryT3":
            this.navigationItems.push({
              text: "Categorías",
              disabled: false,
              href: "#/category",
            });
            this.navigationItems.push({
              text: `${this.$route.params.categoryT2}`,
              disabled: true,
              href: `#/category/${this.$route.params.categoryT2}?idCategory=`,
            });
            this.navigationItems.push({
              text: `${this.$route.params.categoryT3}`,
              disabled: true,
              href: `#/category/${this.$route.params.categoryT2}/${this.$route.params.categoryT3}?idCategory=`,
            });
            break;
          case "categoryT4":
            this.navigationItems.push({
              text: "Categorías",
              disabled: false,
              href: "#/category",
            });
            this.navigationItems.push({
              text: `${this.$route.params.categoryT2}`,
              disabled: true,
              href: `#/category/${this.$route.params.categoryT2}?idCategory=`,
            });
            this.navigationItems.push({
              text: `${this.$route.params.categoryT3}`,
              disabled: true,
              href: `#/category/${this.$route.params.categoryT2}/${this.$route.params.categoryT3}?idCategory=`,
            });
            this.navigationItems.push({
              text: `${this.$route.params.categoryT4}`,
              disabled: true,
              href: `#/category/${this.$route.params.categoryT2}/${this.$route.params.categoryT3}/${this.$route.params.categoryT4}?idCategory=`,
            });
            break;
          case "products":
            this.navigationItems.push({
              text: `Resultados de Búsqueda de "${this.$route.query.value}"`,
              disabled: true,
              href: `#/products?value=${encodeURIComponent(
                this.$route.query.value
              )}`,
            });
            // this.navigationItems.push({
            //   text: `${this.$route.params.categoryT2}`,
            //   disabled: true,
            //   href: `#/category/${this.$route.params.categoryT2}?idCategory=`
            // });
            break;

          case "productDetail":
            this.navigationItems.push({
              text: "Detalles de Producto",
              disabled: true,
              href: `/productDetail/${this.$route.params.sku}`,
            });
            break;
          case "productsCategory":
            // this.navigationItems.push({
            //   text: "Categorías",
            //   disabled: true,
            //   href: "#/category"
            // });
            // this.navigationItems.push({
            //   text: `${this.$route.params.categoryT2}`,
            //   disabled: true,
            //   href: `#/category/${this.$route.params.categoryT2}?idCategory=`
            // });
            // this.navigationItems.push({
            //   text: `${this.$route.params.categoryT3}`,
            //   disabled: true,
            //   href: `#/category/${this.$route.params.categoryT2}/${this.$route.params.categoryT3}?idCategory=`
            // });
            // this.navigationItems.push({
            //   text: `${this.$route.params.categoryT4}`,
            //   disabled: true,
            //   href: `#/category/${this.$route.params.categoryT2}/${this.$route.params.categoryT3}/${this.$route.params.categoryT4}?idCategory=`
            // });
            this.navigationItems.push({
              text: `${this.$route.params.category}`,
              disabled: true,
              // href: `#/category/${this.$route.params.categoryT2}/${this.$route.params.categoryT3}/${this.$route.params.categoryT4}?idCategory=`
              href: `#/category/${this.$route.params.category}?idCategory=`,
            });
            break;
        }
      }
    },

    handleLangSelected(language) {
      this.selectedLanguage = language;
    },

    setLanguage: function (language) {
      switch (language) {
        case "Español":
          localStorage.setItem("isEnglish", false);
          events.$emit("language", false);
          break;
        case "English":
          localStorage.setItem("isEnglish", true);
          events.$emit("language", true);
          break;
      }
    },

    image: function (name) {
      const s3Link = "https://risoulimages.s3-us-west-2.amazonaws.com/BANNERS+";
      switch (name) {
        case "category":
          this.url = `${s3Link}GRAL/CATEGORIAS.webp`;
          break;
        case "PDI":
          this.url = `${s3Link}GRAL/SOLUCIONES+PDI.webp`;
          break;
        case "brands":
          this.url = `${s3Link}GRAL/MARCAS.webp`;
          break;
        case "categoryT2":
          var tier2 = this.$route.params.categoryT2;
          tier2 = this.textFormater(tier2);
          this.url = `${s3Link}NIVELES/NIVEL+1/${tier2}.jpg`;
          break;
        case "PDIT2":
          var tier2 = this.$route.params.PDIT2;
          tier2 = this.textFormater(tier2);
          this.url = `${s3Link}PDI/NIVEL+1/${tier2}.jpg`;
          break;
      }
      this.showBanner = !!this.url ? true : false;
    },

    textFormater: function (name) {
      return name
        .split(" ")
        .join("+")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },

    closeSession: function () {
      events.$emit("closeSession");
      this.isActiveSession();
    },

    verifyToken: function (token) {
      var vm = this;
      var tokenObject = { token: token };
      this.$http.post("loginJWT", tokenObject).then(
        (res) => {
          const data = res.body.decoded;
          localStorage.setItem("userId", data.userId);
          localStorage.setItem("token", data.token);
          localStorage.setItem("name", data.name);
          vm.isActiveSession();
          vm.snackbar("Sesion iniciada con exito");
        },
        (error) => {
          this.snackbar(
            error.message || "Hubo un problema al validar el Token"
          );
        }
      );
    },

    getParentCategory() {
      this.loading = true;

      this.$http
        .get(`category/search?parentId=`)
        .then(
          (response) => {
            var list = response.body.data;
            var pdi = _.filter(list, (c) => {
              return c.pdi == true;
            });
            var nopdi = _.filter(list, (c) => {
              return c.pdi == false && c.name != "SIN CATEGORÍA";
            });
            this.parentCategory.noPDI = nopdi;
            this.parentCategory.PDI = pdi;
          },
          (error) => {
            this.snackbar(
              error.message ||
                "Hubo un problema al obtener la lista de categorias"
            );
          }
        )
        .finally(() => (this.loading = false));
    },
  },

  computed: {
    currentText: function () {
      if (this.selectedLanguage !== "Español") {
        return this.text.english;
      } else {
        return this.text.spanish;
      }
    },

    quantityShopping: function () {
      return this.artQuantity;
    },
  },

  watch: {
    $route() {
      this.$router.go();
      var routeName = this.$route.name;
      if (routeName == "home" || routeName == "login") {
        this.hideBreadcrumbs = true;
      } else {
        this.hideBreadcrumbs = false;
      }
    },
  },

  created: function () {
    this.getParentCategory();
    var keyword = this.$route.query;
    var token = localStorage.getItem("token");
    if (keyword.token && (!token || token != keyword.token))
      this.verifyToken(keyword.token);

    this.isActiveSession();
    if (
      this.$route.name == "brands" ||
      this.$route.name == "PDI" ||
      this.$route.name == "PDIT2" ||
      this.$route.name == "PDIT3" ||
      this.$route.name == "category" ||
      this.$route.name == "categoryT2" ||
      this.$route.name == "categoryT3"
    ) {
      this.image(this.$route.name);
    } else {
      this.showBanner = false;
    }
    this.updateShopingQuantity();
  },

  mounted() {
    window.scrollTo(0, 0);
    this.breadcrumb();
  },
};
</script>

<style>
/*
 * Aplican a todos los componentes
 */

@media (min-width: 960px) {
  .content-container {
    max-width: 980px;
    background-color: white !important;
  }
}

@media (min-width: 1264px) {
  .content-container {
    max-width: 1129px;
    background-color: white !important;
  }
}

@media (min-width: 1879px) {
  .content-container {
    max-width: 1691px;
    margin-left: auto;
    background-color: white !important;
  }
}

@media (min-width: 1904px) {
  .content-container {
    max-width: 1556px;
    margin: auto;
    background-color: white !important;
  }
}

@media (min-width: 768px) {
}

@media (min-width: 992px) {
}

@media (min-width: 1200px) {
}

.margin0 {
  margin: 0 !important;
}

.footer-text {
  color: #a9a9a9 !important;
  font-size: 13px;
}

.pa-2 .paddRight {
  padding-right: 40px !important;
}

.secondaryButton {
  color: #fa6b17;
}

.pb0 {
  padding-top: 24px;
  padding-bottom: 0px;
}

.lg5-custom {
  width: 200px;
  padding: 16px;
}

.searcher {
  background-color: white;
}

.v-menu__content {
  max-height: 1000px !important;
}

.v-toolbar__content,
.v-toolbar__items {
  width: 100%;
}

.v-toolbar__content {
  padding-right: 0 !important;
}
</style>

<style scoped>
/*
 * Scoped (Solo aplican a este componente) 
 */
.banner-container {
  padding-top: 0;
  padding-bottom: 0;
}

.banner {
  padding: 0px;
  width: 100%;
  height: 100%;
  background-size: 100%;
}

.footer-container {
  margin-top: 16px;
  padding-top: 16px;
  padding-bottom: 5vh;
  padding-left: 5vh;
  padding-right: 5vh;
  -webkit-box-shadow: 0px -4px 9px -2px rgba(148, 148, 148, 0.45);
  -moz-box-shadow: 0px -4px 9px -2px rgba(148, 148, 148, 0.45);
  box-shadow: 0px -4px 9px -2px rgba(148, 148, 148, 0.45);
}

.footer-title {
  display: block;
  color: #073c79;
  text-transform: uppercase;
  font-size: 18px;
  margin: 20px 0;
  font-family: "ProximaNova-Bold", sans-serif;
}

.footer-title:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 15px;
  height: 3px;
  background-color: #00489f;
}

.footer-caption {
  font-size: 1.5rem;
}

.footer-list {
  max-height: 300px;
}

ul {
  list-style: none;
}

.footer-list ul li::before {
  content: "\2022";
  color: #fd6c17;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

.footer-list li a {
  color: #555;
  font-size: 15px;
  text-decoration: none;
}

.boxesapp {
  display: flex;
  align-items: center;
}

.boxesapp a {
  width: 40%;
  display: block;
  margin-right: 10px;
}

.boxesapp a img {
  width: 100%;
  max-width: 100%;
  display: block;
  margin: 0 auto;
}

.v-footer {
  padding: 16px;
}

.footer-links {
  width: 44px;
  border-width: 0px;
  border: 0px;
}

.footer-parent {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.footer-parent col {
  padding: 0 !important;
}

.footer-menu {
  grid-area: 1 / 1 / 2 / 4;
}
.footer-locations {
  grid-area: 2 / 1 / 3 / 4;
}
.footer-contact {
  grid-area: 1 / 4 / 3 / 5;
}

.li-element {
  float: left;
  list-style: none;
}

.navigation-header {
  height: 110px;
}

.navigation-bar {
  min-width: 100%;
  height: 46px;
}

.navigation-bar .v-toolbar__content {
  padding: 0 !important;
}

.header-text {
  font-size: 12px;
  color: white !important;
  cursor: pointer;
  width: 100px;
}
.menu-text {
  color: white;
}

.list-element:hover {
  cursor: pointer;
  color: black !important;
}
</style>
